import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="wrapper">
        <div className="opacity" />
        <div className="gravity">
          <div className="container">
            <div className=" row">
              <div className="col-md-12">
                <p>Estamos trabajando en algo fabuloso </p>
              </div>
            </div>
          </div>
        </div>
        <div className="email">
          <div className="container">
            <div className=" row">
              <div className="col-md-12">
                <p style={{ fontSize: 50 }}>Pagina en construccion<br />🏗️</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}

export default App;
